// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .tab-container {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
  }
  
  .tab {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s ease;
  }
  
  .tab.active {
    background-color: #2563eb;
    color: white;
  }
  
  .tab:not(.active) {
    background-color: #e5e7eb;
  }
  
  .form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 30px;
  }
  
  .input-field {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }
  
  .time-container {
    display: flex;
    gap: 15px;
  }
  
  .time-container input {
    flex: 1 1;
  }
  
  .add-button {
    padding: 10px;
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
  }
  
  .add-button:hover {
    background-color: #1d4ed8;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  th, td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
  }
  
  th {
    background-color: #f3f4f6;
    font-weight: bold;
  }
  
  tr:nth-child(even) {
    background-color: #f8f9fa;
  }
  
  .delete-button {
    padding: 6px 12px;
    background-color: #dc2626;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .delete-button:hover {
    background-color: #b91c1c;
  }
  
  @media (max-width: 768px) {
    .time-container {
      flex-direction: column;
    }
    
    .table-container {
      overflow-x: scroll;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/studentComponents/liveClassWorkShop.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":[".container {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n  }\n  \n  .tab-container {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 30px;\n  }\n  \n  .tab {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: all 0.3s ease;\n  }\n  \n  .tab.active {\n    background-color: #2563eb;\n    color: white;\n  }\n  \n  .tab:not(.active) {\n    background-color: #e5e7eb;\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 30px;\n  }\n  \n  .input-field {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n  \n  .time-container {\n    display: flex;\n    gap: 15px;\n  }\n  \n  .time-container input {\n    flex: 1;\n  }\n  \n  .add-button {\n    padding: 10px;\n    background-color: #2563eb;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .add-button:hover {\n    background-color: #1d4ed8;\n  }\n  \n  .table-container {\n    overflow-x: auto;\n  }\n  \n  table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n  }\n  \n  th, td {\n    border: 1px solid #ddd;\n    padding: 12px;\n    text-align: left;\n  }\n  \n  th {\n    background-color: #f3f4f6;\n    font-weight: bold;\n  }\n  \n  tr:nth-child(even) {\n    background-color: #f8f9fa;\n  }\n  \n  .delete-button {\n    padding: 6px 12px;\n    background-color: #dc2626;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .delete-button:hover {\n    background-color: #b91c1c;\n  }\n  \n  @media (max-width: 768px) {\n    .time-container {\n      flex-direction: column;\n    }\n    \n    .table-container {\n      overflow-x: scroll;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
